<template>
  <div class="container boardcontainer">
    <div class="jumbotron text-center board pt-0" style="background: #ffffff">
      <h2 class="title_brand">
        1Click 商聯快通 <span class="title_brandsub">索取電子型錄 即掃即得</span>
      </h2>

      <h2 class="title">{{ showName }}</h2>
      <h2 class="title_storename">{{ companyName }}</h2>

      <div v-if="url !== ''" class="mb-5">
        <vue-qr :text="url" :size="size"></vue-qr>
      </div>

      <div class="boxTopText mb-3">
        ＃同會場不需重複填寫資料 ＃一掃即得品牌資訊 ＃無紙化遞送品牌資訊 ＃自動彙整並Email參訪清單
        ＃安全無接觸式商務資訊交換 ＃毋需人工整理參訪資料
      </div>

      <div class="box row justify-content-between mb-5 mx-5">
        <div class="boxSideText">使<br />用<br />步<br />驟</div>

        <div class="item">
          <div class="title">掃描展覽<br />QrCode</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            fill="#ffffff"
            class="bi bi-upc-scan"
            viewBox="0 0 16 16"
          >
            <path
              d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"
            />
          </svg>
        </div>
        <div class="item">
          <div class="title">按下連結<br />打開瀏覽器</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            fill="#ffffff"
            class="bi bi-window"
            viewBox="0 0 16 16"
          >
            <path
              d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
            />
            <path
              d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm13 2v2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zM2 14a1 1 0 0 1-1-1V6h14v7a1 1 0 0 1-1 1H2z"
            />
          </svg>
        </div>
        <div class="item">
          <div class="title">填寫資料<br />(初次入場須填)</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            fill="#ffffff"
            class="bi bi-file-earmark-text"
            viewBox="0 0 16 16"
          >
            <path
              d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
            />
            <path
              d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"
            />
          </svg>
        </div>
        <div class="item">
          <div class="title">快速完成<br />商務資料索取</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            fill="#ffffff"
            class="bi bi-check2-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"
            />
            <path
              d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"
            />
          </svg>
        </div>
        <div class="item">
          <div class="title">收取品牌<br />資料</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            fill="#ffffff"
            class="bi bi-envelope"
            viewBox="0 0 16 16"
          >
            <path
              d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"
            />
          </svg>
        </div>
      </div>
      <h2>{{ companyName }} 期待合作</h2>
      <h2 class="power">
        power by <span><img :src="logo" alt /></span>
      </h2>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr/src/packages/vue-qr.vue";

export default {
  name: "BoothBoard",
  components: {
    VueQr,
  },
  data: function () {
    return {
      showId: "",
      showName: "",
      companyName: "",
      boothId: "",
      boothName: "",
      size: window.innerWidth / 2,
      logo: "/images/img_logo.png",
      url: "",
    };
  },
  created() {
    this.showId = "";
    this.boothId = this.$route.params.boothId;
    this.url = "";
    this.initialLoad(this.$route.params.boothId);
  },
  methods: {
    initialLoad: function (boothId) {
      const data = { SID: boothId };
      this.$BoothAPI
        .queryBoothProfile(data)
        .then((res) => {
          const resultStr = res.data;
          const resultObj = JSON.parse(resultStr);
          if (resultObj.body.MESSAGE === "SUCCESS") {
            this.showId = resultObj.body.SHOW_ID;
            this.showName = resultObj.body.SHOW_NAME;
            this.companyName = resultObj.body.COMPANY_NAME;
            this.url = "https://oneclick.ysct.app/BoothBoardVisit/" + this.$route.params.boothId;
          } else {
            this.$alert.warningAlert(resultObj.body.MESSAGE);
          }
        })
        .catch((error) => {
          this.$alert.warningAlert(error);
          console.error(error);
        });
    },
  },
};
</script>

<style scoped></style>
